import { Card, CardHeader, CardBody, Progress, Row, Col, Spinner } from "reactstrap";
import { VacancyLeaseExpiryTab, StatCard } from "./VacancyLeaseExpiryTab";

const progress = (n, total) => (total ? Math.round((n / total) * 100) : 0);

/**
 * "Overview" — the report's first screen, and the merge of what used to be two tabs.
 *
 * The old Summary tab's document/insurance health and the old Vacancy & Expiry tab's
 * lease pressure answer the same question ("what needs doing on this building?"), so
 * they share one view: a slim health band across the top, then a single tile grid
 * carrying both reports' actionable counts, then Vacancy & Expiry's own filter, Excel
 * export and unit table — untouched, so nothing either tab could do was lost.
 */
const OverviewTab = ({ summary, summaryLoading, masterSheetData }) => {
  const docTiles = summary ? (
    <>
      <StatCard label="Missing required docs" count={summary.missingRequired.length} tone={summary.missingRequired.length ? "red" : "green"} />
      <StatCard label="Insurance expired" count={summary.expiredInsurance.length} tone={summary.expiredInsurance.length ? "red" : "green"} />
      <StatCard label="No insurance date" count={summary.withoutInsurance} tone={summary.withoutInsurance ? "amber" : "green"} />
    </>
  ) : null;

  return (
    <>
      {summaryLoading ? (
        <div className="text-center p-4">
          <Spinner color="primary" /> Loading document status...
        </div>
      ) : summary ? (
        <Card className="mb-3">
          <CardHeader className="bg-primary text-white">
            Units Overview (Total Units: {summary.total})
          </CardHeader>
          {/* The three health meters that were the whole Summary tab, side by side so
              the lease numbers below them stay above the fold. */}
          <CardBody className="py-3">
            <Row className="g-3">
              <Col md={4}>
                <p className="mb-1" style={{ fontSize: 13 }}>
                  <strong>With Tenant:</strong> {summary.withTenant} ({progress(summary.withTenant, summary.total)}%)
                </p>
                <Progress value={progress(summary.withTenant, summary.total)} color="info" style={{ height: 8 }} />
              </Col>
              <Col md={4}>
                <p className="mb-1 d-flex justify-content-between align-items-center" style={{ fontSize: 13 }}>
                  <span>
                    <strong>Without Insurance Date:</strong> {summary.withoutInsurance} ({progress(summary.withoutInsurance, summary.total)}%)
                  </span>
                  <span style={{ color: "red", fontSize: "0.85em" }}>{summary.expiredInsurance.length} expired</span>
                </p>
                <Progress value={progress(summary.withoutInsurance, summary.total)} color="warning" style={{ height: 8 }} />
              </Col>
              <Col md={4}>
                <p className="mb-1" style={{ fontSize: 13 }}>
                  <strong>All Required Docs:</strong> {summary.withAllRequired} ({progress(summary.withAllRequired, summary.total)}%)
                </p>
                <Progress value={progress(summary.withAllRequired, summary.total)} color="success" style={{ height: 8 }} />
              </Col>
            </Row>
          </CardBody>
        </Card>
      ) : (
        <p className="text-muted">No data available.</p>
      )}

      <VacancyLeaseExpiryTab masterSheetData={masterSheetData} headerTiles={docTiles} />
    </>
  );
};

export { OverviewTab };
